/** 표시 이름과 로그인이 같으면 한 줄만 노출 */
export function getAuthorLines(author) {
  const login = String(author?.login_id || '').trim();
  const name = String(author?.name || '').trim();
  if (login && name && name.toLowerCase() === login.toLowerCase()) {
    return { primary: login, secondary: null };
  }
  if (name && login) return { primary: name, secondary: login };
  if (name) return { primary: name, secondary: null };
  if (login) return { primary: login, secondary: null };
  return { primary: '-', secondary: null };
}

function resolveNoticeRoleKind(roles) {
  const set = new Set((roles || []).map((x) => String(x).toLowerCase()));
  if (set.has('teacher')) return 'teacher';
  if (set.has('parent')) return 'parent';
  if (set.has('student')) return 'student';
  return null;
}

/** 강사 T / 학부모님·학생 접미사를 붙인 첫 줄 */
export function formatNoticeAuthorPrimary(author) {
  const { primary } = getAuthorLines(author);
  const kind = resolveNoticeRoleKind(author?.roles);
  if (kind === 'teacher') return `${primary} T`;
  if (kind === 'parent') return `${primary} 학부모님`;
  if (kind === 'student') return `${primary} 학생`;
  return primary;
}

export function getNoticeAuthorDisplay(author) {
  const { secondary } = getAuthorLines(author);
  return {
    primary: formatNoticeAuthorPrimary(author),
    secondary,
  };
}
